// VERSION : 0.0.1
// AUTHOR : VIGNESH
// LAST EDIT : VIGNESH
// MODIFIED DATE: 07-12-2025
// LAST CHANGED : ADDED COMMENT LINES
import { takeLatest, put, all, call } from 'redux-saga/effects';
import DataVerificationReportActionTypes from './data-verification-report.type';
import { dataVerificationReportListGet } from './data-verification-report.service';
import {
	getDataVerificationReportDetailsSuccess,
	getDataVerificationReportDetailsFailure,
	getDataVerificationReportDetailsResponseChanged,
} from './data-verification-report.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';

/****************  GET DATA VERIFICATION REPORT LIST START *********************** */
export function* getDataVerificationReportList({ payload }: any) {
	try {
		const { companyID, branchID, centerID, databaseName, userLevel, userID, userRole, limit } =
			payload;

		const key = 'DataVerificationReportKey';
		const jsonData = {
			CompanyID: companyID,
			BranchID: branchID,
			CenterID: centerID,
			DatabaseName: databaseName,
			UserLevel: userLevel,
			UserID: userID,
			UserRole: userRole,
			Limit: limit,
		};

		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(dataVerificationReportListGet, encodeData);

		if (responseData.data.statusCode === '401') {
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getDataVerificationReportDetailsFailure(responseData.data));
		} else {
			yield put(getDataVerificationReportDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getDataVerificationReportDetailsFailure(error));
	}
}

export function* resetGetDataVerificationReportListResponse() {
	yield put(getDataVerificationReportDetailsResponseChanged());
}

export function* onGetDataVerificationReportListDetails() {
	yield takeLatest(
		DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_START,
		getDataVerificationReportList,
	);
}

export function* onGetDataVerificationReportListResponseReset() {
	yield takeLatest(
		DataVerificationReportActionTypes.GET_DATA_VERIFICATION_REPORT_LIST_RESPONSE_RESET,
		resetGetDataVerificationReportListResponse,
	);
}
/****************  GET DATA VERIFICATION REPORT LIST END *********************** */

export function* reportDataVerificationSaga() {
	yield all([
		call(onGetDataVerificationReportListDetails),
		call(onGetDataVerificationReportListResponseReset),
	]);
}
